var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVinyl = function SvgVinyl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.541 38.541",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.271,0C8.628,0,0,8.628,0,19.271s8.628,19.271,19.271,19.271s19.271-8.628,19.271-19.271S29.913,0,19.271,0L19.271,0z M19.271,25.479c-3.429,0-6.208-2.779-6.208-6.208s2.779-6.208,6.208-6.208s6.208,2.779,6.208,6.208S22.699,25.479,19.271,25.479L19.271,25.479z M19.796,19.271c0,0.29-0.235,0.525-0.525,0.525s-0.525-0.235-0.525-0.525s0.235-0.525,0.525-0.525l0,0C19.561,18.746,19.796,18.98,19.796,19.271z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVinyl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vinyl.b39e9105.svg";
export { ForwardRef as ReactComponent };